document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener(
    'blur',
    event => {
      if (event.target.matches('.js-textarea-cleanup textarea')) {
        let value = event.target.value;

        // Remove quotes at start and quotes followed by spaces at end
        const updatedValue = value
          .replace(/^["']/, '') // Remove quote at start
          .replace(/["']\s*$/, ''); // Remove quote followed by spaces at end

        if (value !== updatedValue) {
          event.target.value = updatedValue;
        }
      }
    },
    true
  );
});
